module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDMgMTAiPjxkZWZzPjxwYXRoIGlkPSJsNHE1YSIgZD0iTTI0MyA1MjJ2LTZoLTJ2LTFoM3Y3em0wLThjLS41NSAwLTEtLjQ2LTEtMWExIDEgMCAwIDEgMiAwYzAgLjU0LS40NSAxLTEgMXoiLz48L2RlZnM+PGc+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI0MSAtNTEyKSI+PHVzZSBmaWxsPSIjYzZjOGNjIiB4bGluazpocmVmPSIjbDRxNWEiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/glossary-icon.svg
// module id = Vw/Y
// module chunks = 1